import { render } from "./AIHelper.vue?vue&type=template&id=4ff81029&scoped=true"
import script from "./AIHelper.vue?vue&type=script&lang=js"
export * from "./AIHelper.vue?vue&type=script&lang=js"

import "./AIHelper.vue?vue&type=style&index=0&id=4ff81029&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff81029"]])

export default __exports__